'use client';
import React, { useRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "primereact/button";
import Product from "../products/Product";
import { Toast } from 'primereact/toast';

const LatestProducts = () => {
    const { t } = useTranslation();
    const carouselRef = useRef();
    const storeFrontData = useSelector((state) => state.app.storeData);
    const products = storeFrontData.latestProducts;
    const toast = useRef();
    const responsive = {
        tv: {
            breakpoint: { max: 3000, min: 1700 },
            items: 7,
            slidesToSlide: 1
        },
        desktop: {
            breakpoint: { max: 1700, min: 960 },
            items: 6,
            slidesToSlide: 1
        },
        tablet: {
            breakpoint: { max: 959, min: 760 },
            items: 3,
            slidesToSlide: 1
        },
        mobile: {
            breakpoint: { max: 760, min: 0 },
            items: 2,
            slidesToSlide: 2
        }
    };
    return (
        <div>
            <Toast ref={toast}
                position="bottom-center"
            />
            <div className="flex justify-between center-items mt-10 lg:mx-6 mx-2">
                <h1 className="font-bold text-xl">{t('latest_products')}</h1>
                <Link className="text-sm border rounded-full px-5 py-2 font-bold"
                    to={'/shop/latest'}
                >
                    {t('see_all')}
                </Link>
            </div>
            <div className="lg:mx-8">
                <Carousel
                    ref={carouselRef}
                    swipeable={true}
                    draggable={true}
                    showDots={false}
                    responsive={responsive}
                    ssr={true}
                    infinite={true}
                    autoPlay={false}
                    autoPlaySpeed={1000}
                    keyBoardControl={true}
                    customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["mobile", "desktop", "tablet", "tv"]}
                >
                    {
                        products.map((item) => {
                            return (
                                <div key={item.id}>
                                    <Product item={item}
                                        showToast={() => {
                                            toast.current.show({ severity: 'success', detail: t('item_added_to_cart'), life: 3000 });
                                        }}
                                    />
                                </div>

                            );
                        })
                    }
                </Carousel>
            </div>
            <div className="flex items-center content-center"
                style={{
                    direction: "initial"
                }}
            >
                <div className="mx-3">
                    <Button className="!w-10 !h-10" outlined rounded severity="secondary" icon={<span className="material-symbols-outlined">chevron_backward</span>}
                        onClick={() => {
                            carouselRef.current.previous();
                        }}
                    />
                </div>
                <div className="mx-3">
                    <Button className="!w-10 !h-10" outlined rounded severity="secondary" icon={<span className="material-symbols-outlined">chevron_forward</span>}
                        onClick={() => {
                            carouselRef.current.next();
                        }}
                    />
                </div>
            </div>
        </div>

    );
}
export default LatestProducts;